<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 500px;" class="detail">
        <el-form ref="infoForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="activityName">
            <el-input v-model="ruleForm.activityName" :disabled="true" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker v-model="ruleForm.activityTime" :disabled="true" type="daterange" range-separator="至" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input v-model="ruleForm.activityExplain" :disabled="true" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
          <el-form-item label="活动文案" prop="activityCopywriting">
            <img :src="this.action+'?objectName='+ruleForm.activityCopywriting" class="avatar">
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <template v-for="(row,index) in configForm.coupons[0].coupons">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="activityReward">
              <div class="d-flex">
                <el-select v-model="row.couponId" :disabled="true" style="width: 200px;" placeholder="请选择优惠券">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" :disabled="true" class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                <div class="ml-20">张</div>
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" :rules="partakeRules" label-width="100px">
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType" disabled>
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <!-- <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" /> -->
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.userValue"
                :props="treeDefaultProps"
                :check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <!-- <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" /> -->
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.userValue"
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户参与记录</span>
      </div>
      <STable
        ref="detailTableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
import { numberfilter } from '@/utils/tool'
import { treeDisabled } from '@/utils/tool'
export default {
  props: {
    // 活动信息表单的详情数据
    formData: {
      type: Object,
      default() {
        return {

        }
      }
    },
    // 预留的id，通过id查询详情信息
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      // 活动信息表单数据
      ruleForm: {},
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ],
        activityCopywriting: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动配置表单数据
      configForm: {
        coupons: [
          {
            coupons: []
          }
        ]
      },
      configRules: {
        activityReward: { required: true, trigger: 'change', validator: (rewardRules, value, cb) => {
          if (this.rulesConfigRule) {
            return cb(new Error(this.rulesConfigRule))
          }
          return cb()
        } }
      },
      // 可参与用户字段的单选数据
      userTypeItem: [
        {
          label: '全部用户',
          id: '1'
        }, {
          label: '选择企业',
          id: '2'
        }, {
          label: '选择标签',
          id: '3'
        }
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      // 可参与用户表单数据
      partakeForm: {},
      partakeRules: {},
      url: '/activity/pageParticipation',
      columns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'loginName'
        },
        {
          label: '用户姓名',
          prop: 'userName'
        },
        {
          label: '手机号',
          prop: 'mobile'
        },
        {
          label: '分享时间',
          prop: 'createTime'
        }
      ],
      query: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        }, {
          label: '用户账号',
          prop: 'loginName',
          placeholder: '请输入用户账号'
        }, {
          label: '手机号',
          prop: 'mobile',
          placeholder: '请输入手机号'
        }, {
          label: '分享时间',
          prop: 'timeRange',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
		  icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/activity/exportParticipation?activityId=' + this.id
            const data = this.$refs.detailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出用户参与记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {
    action() {
      return HOST + '/oss'
    },
    // 活动配置表单的动态校验
    rulesConfigRule() {
      const dataArray = this.configForm.coupons[0].coupons
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
      }
      return ''
    }
  },
  beforeMount() {
    
    this.id=this.$route.query.id
    this.url = '/activity/pageParticipation?activityId=' + this.id
  },
  mounted() {
      this.formData=JSON.parse(decodeURIComponent(this.$route.query.infoForm))
    // 获取全部优惠券数据
    this.loadCoupon()
    // 查询全部企业方法
    this.getMechanismTree()
    // 查询全部标签方法
    this.getTagTree()
    this.$nextTick(() => {
      this.ruleForm = JSON.parse(JSON.stringify(this.formData.ruleForm))
      this.configForm = JSON.parse(JSON.stringify(this.formData.configForm))
      this.partakeForm = JSON.parse(JSON.stringify(this.formData.partakeForm))
      console.log('传过来的数据', this.configForm)
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    back() {
      // this.$emit('backHome')
           this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .image{
    width: 100%;
    height: 180px;
  }
  .d-flex{
    display: flex;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .avatar {
    max-height: 200px;
    width: auto;
  }
  .mt-25{
    margin-top: 25px;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  .detail{
    /deep/.el-input__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-textarea__inner{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-input{
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }
    /deep/.el-range-separator{
      color: #606266 !important;
    }
    /deep/.el-range__icon{
      color: #606266 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/shareDetail.vue